import React from "react";
import { DataFieldInputSelector } from "@/components/DataFieldInputSelector";
import { ConfigForm_SectionWrapper } from "../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { TitleInputWithDefault } from "../../utils/TitleInputWithDefault";
import { usePieChartConfig } from "./ConfigForm_Context";
import { DATA_KEYS } from "./DATA_KEYS";

const PIE_CHART_TYPE_OPTIONS = [
  { display: "Single Layer", value: "singleLayer", iconName: "ChartDonut", dataType: "Type" },
  { display: "Multi Layer (Sunburst)", value: "multiLayer", iconName: "CirclesThree", dataType: "Type" },
];

export const ConfigForm_TypeSection = () => {
  const { widgetConfig, setConfig, underEditWidgetIdx, pieChartType, handlePieChartTypeChange } = usePieChartConfig();

  const typeValue = PIE_CHART_TYPE_OPTIONS.find(o => o.value === pieChartType) || PIE_CHART_TYPE_OPTIONS[0];

  return (
    <ConfigForm_SectionWrapper>
      
      <TitleInputWithDefault
        widgetConfig={widgetConfig}
        widgetType="WidgetPieChart"
        setConfig={setConfig}
        underEditWidgetIdx={underEditWidgetIdx}
        titlePath={DATA_KEYS.field1}
        label="Custom chart title"
        placeholder="Enter title"
      />

      <DataFieldInputSelector
        id="pieChartType"
        options={PIE_CHART_TYPE_OPTIONS}
        value={typeValue}
        onChange={(id, v) => handlePieChartTypeChange(v.value)}
        placeholder="Select Type"
        placeholderIcon="ChartDonut"
        trailingIcon="CaretRight"
        hideSearchHeader
      />
    </ConfigForm_SectionWrapper>
  );
};
